/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': '로드 중...',
	'dlg_close': '닫기',
	'dlg_ok': '확인',
	'dlg_cancel': '취소',
	'dlg_back': '되돌아가기',
	'dlg_done': '완료',
	'dlg_save': '저장',

	// Slider
	'sliderRegionLabel': '슬라이더 제어. 슬라이더 핸들을 이동하려면 왼쪽 및 오른쪽 화살표를 사용하십시오.',
	'sliderHandleLabel': '슬라이더 핸들',
	'a11ySliderHandleLabel': '슬라이더 핸들 %{sliderValue}',
	'sliderInputLabel': '값',

	// Side bar
	'sidebarAdd': '추가',
	'clearTextFilterValue': '지우기',
	'missingDataSetData': '이 데이터 세트의 데이터를 사용할 수 없습니다. 데이터 세트를 새로 고치거나 소스 액세스에 대해 관리자에게 문의하십시오.',

	// Toolbar
	'toolbarRegionLabel': '도구 모음',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': '글꼴 패밀리',
	'fontFamilyStyle': '글꼴 스타일',
	'regularFontStyle': '일반',
	'fontSizeSelect': '글꼴 크기',
	'fontColorSelect': '색상',
	'fontStyle': '스타일',
	'colorPickerTitle': '색상 선택',
	'bold': '굵게',
	'italic': '기울임꼴',
	'underline': '밑줄',
	'fontAlignment': '맞춤',
	'justifyLeft': '왼쪽 맞춤',
	'justifyCenter': '가운데 맞춤',
	'justifyRight': '오른쪽 맞춤',
	'insertOrderedList': '정렬된 목록',
	'insertUnorderedList': '정렬되지 않은 목록',
	'fontColorPicker': '색상 선택도구',
	'textWrap': '텍스트 줄 바꾸기',
	'restore': '기본값 복원',
	'textAutoFontSize': '자동',
	'textDefaultFontSize': '기본값',
	'textItemTitle': '제목',
	'textLabelShadow': '레이블 음영',
	'textContrastLabelColor':'대조 색상',
	'toggleOn': '켜기',
	'toggleOff': '꺼짐',
	'contrastLabelColorInfo': '내게 필요한 옵션의 레이블 색상을 자동 조정하십시오. 글꼴 색상을 대체합니다.',
	'labelShadowInfo':'내게 필요한 옵션을 위해 음영을 텍스트에 추가하십시오.',
	'applyToAll':'모든 축에 스타일링 적용',

	// Top Bottom
	'topbottomNumberOfResultsLabel': '결과 수(%{lower} - %{higher})',
	'topbottomPercentLabel': '퍼센트(%{lower}% - %{higher}%)',
	'topbottomSelectOption': '맨 위 또는 맨 아래 옵션',
	'topbottomOptionLabel': '표시',
	'searchByLabel': '기준',
	'searchNoMatches': '일치 항목 없음',
	'topbottomRankColumnLabel': '테이블에 등급 열 추가',
	'topbottomNone': '없음',
	'topCount': '상위 개수',
	'topPercent': '상위 %',
	'bottomCount': '하위 개수',
	'bottomPercent': '하위 %',
	'searchColumn': '열 찾기',
	'searchColumnAriaLabel': '열을 찾습니다. 검색할 열의 이름을 입력한 후 아래로 화살표를 사용하여 목록에서 열을 찾으십시오.',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': '등급(%{columnLabel})',
	'topbottomClearLabel': '재설정',

	// Format
	'formatAuto': '자동',
	'formatConvertPercent': '10진수를 백분율로 변환',
	'formatAbbreviate': '축약',
	'formatUseGrouping': '천 단위 구분 기호 사용',
	'dateStyle': '날짜 스타일',
	'dateTimeStyle': '날짜/시간 스타일',
	'formatMissingValueCharactersInfo': '값이 누락된 경우 누락 값 문자는 표시할 문자를 지정합니다.',
	'currencySymbolLabel': '통화 기호',
	'customSymbolPlaceholder': '기호 추가',
	'customSymbolLabelInfo': '사용자 정의 기호로 사용할 하나 이상의 문자를 지정합니다. 이 기호는 숫자와 기호보다 앞에 표시됩니다.',
	'numberLabel': '숫자 레이블',
	'numberPositionLabel': '레이블 위치',
	'negativeSignPosition': '음수 기호 위치',
	'negativeSign': '음수 기호',
	'numberLabelInfo': '레이블 위치에 따라 접두부 또는 접미부로 배치되는, 형식화된 숫자의 레이블을 지정합니다.',
	'nullValueDefault': '<default>',
	'nullValueContent': '(값 없음)',
	'default': '기본값',
	'beginning': '시작',
	'end': '종료',
	'formatLabel': '형식 선택',

	// More data indicator
	'moreDataIndicator': '%{threshold} 항목에서 데이터가 클립되었습니다. 더 적게 표시하려면 필터를 적용하십시오.',

	// Expanded View / Focus mode
	'evCollapse': '접기',
	'duplicate': '복제',
	'copyOf': '%{name}의 사본',
	'unableToDuplicateBoard': '"%{name}"을(를) 복제할 수 없습니다.',

	// Widget list
	'errorLoadingWidgetList': '오브젝트를 로드할 수 없습니다.',

	// Custom widgets
	'customWidget': '사용자 정의 위젯',

	// Auto group
	'group': '그룹',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': '헤어라인',
	'textFontFamilySubClassThin': '얇음',
	'textFontFamilySubClassThinItalic': '얇은 기울임꼴',
	'textFontFamilySubClassExtraLight': '매우 미세함',
	'textFontFamilySubClassExtraLightItalic': '매우 미세한 기울임꼴',
	'textFontFamilySubClassLight': '밝음',
	'textFontFamilySubClassLightItalic': '미세한 기울임꼴',
	'textFontFamilySubClassRegular': '정기',
	'textFontFamilySubClassRegularItalic': '일반 기울임꼴',
	'textFontFamilySubClassItalic': '기울임꼴',
	'textFontFamilySubClassMedium': '중간',
	'textFontFamilySubClassMediumItalic': '중간 기울임꼴',
	'textFontFamilySubClassHeavy': '진함',
	'textFontFamilySubClassHeavyItalic': '진한 기울임꼴',
	'textFontFamilySubClassDemiBold': '반굵게',
	'textFontFamilySubClassDemiBoldItalic': '반굵게 기울임꼴',
	'textFontFamilySubClassBold': '굵게',
	'textFontFamilySubClassBoldItalic': '굵게 기울임꼴',
	'textFontFamilySubClassExtraBold': '매우 굵게',
	'textFontFamilySubClassExtraBoldItalic': '매우 굵게 기울임꼴',
	'textFontFamilySubClassBlack': '검은색',
	'textFontFamilySubClassBlackItalic': '검은 기울임꼴',
	'textFontFamilySubClassStencil': '스텐실',
	// END: Remove FontFamilySubClass
});
